<template>
  <Card class="residential-mutate-residential-account">
    <template #default>
      <Loader :value="true" theme="default" />
    </template>
  </Card>
</template>

<script>
import { i18n } from '@/i18n'
import { mapState, mapActions } from 'vuex'

import Card from '@/components/Card'

const meta = {
  order: 5,
  id: 'residential-account',
  label: i18n.tc('residentialAccount'),
  icon: ['fal', 'home'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    isActive: Boolean,
  },
  watch: {
    residentialAccount: {
      handler: 'prepare',
      immediate: true,
    },
    isActive: {
      handler: 'prepare',
      immediate: true,
    },
  },
  computed: {
    ...mapState('Residential', {
      id: state => state.item.id,
      residentialAccount: state => state.item.residentialAccount,
    }),
    ...mapState('ResidentialAccount', ['promises']),
  },
  methods: {
    ...mapActions('ResidentialAccount', {
      async create(dispatch) {
        if (this.residentialAccount) return this.residentialAccount
        return dispatch('mutate', { reference: { onModel: 'Residential', ref: this.id } })
      },
    }),
    prepare() {
      let redirect = id => this.$router.replace({ name: 'residential-account-mutate', params: { id } })

      if (!this.isActive) return

      return this.create().then(({ id }) => redirect(id))
    },
  },
  components: {
    Card,
  },
}
</script>

<style lang="scss">
.residential-mutate-residential-account {
  max-width: 900px;
}
</style>
